import EmailNotification from 'models/notification/email/EmailNotification';

/**
 * Class representing a remember pass email notification.
 * @extends EmailNotification
 */
export default class RememberPassEmailNotification extends EmailNotification {
	_type = 'remember-pass';
}
